import { render, staticRenderFns } from "./Vessel.vue?vue&type=template&id=f21a7852"
import script from "./Vessel.vue?vue&type=script&lang=js"
export * from "./Vessel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports